import * as $runtime from "../runtime.js";
import * as Control$dBind from "../Control.Bind/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Restaumatic$dMenu$dV2$dMemo from "../Restaumatic.Menu.V2.Memo/index.js";
import * as Restaumatic$dMenu$dV2$dParametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
const modifierItemParameters = item => Data$dFoldable.foldableArray.foldMap({
  mempty: Data$dMap$dInternal.Leaf,
  Semigroup0: () => ({append: Data$dSet.union(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)})
})(x => x)([
  Restaumatic$dMenu$dV2$dParametric.parametricParams(Data$dRecord.unsafeGet("availableWhen")(item)),
  Restaumatic$dMenu$dV2$dParametric.parametricParams(Data$dRecord.unsafeGet("price")(item))
]);
const modifierParameters = catalogue => modifierId => Restaumatic$dMenu$dV2$dMemo.memoLookup(Restaumatic$dMenu$dV2$dMemo.ordParametersMemoKey)(catalogue.parametersMemo)(Restaumatic$dMenu$dV2$dMemo.$ParametersMemoKey(
  "ModifierParameters",
  modifierId
))(v => {
  const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(modifierId)(Data$dRecord.unsafeGet("modifiers")(catalogue.catalogue));
  if ($0.tag === "Nothing") { return Data$dMap$dInternal.Leaf; }
  if ($0.tag === "Just") {
    return Data$dFoldable.foldableArray.foldMap({
      mempty: Data$dMap$dInternal.Leaf,
      Semigroup0: () => ({append: Data$dSet.union(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)})
    })(x => x)([
      Restaumatic$dMenu$dV2$dParametric.parametricParams($0._1.availableWhen),
      Restaumatic$dMenu$dV2$dParametric.parametricParams($0._1.userEditableWhen),
      Data$dFoldable.foldableArray.foldMap({
        mempty: Data$dMap$dInternal.Leaf,
        Semigroup0: () => ({append: Data$dSet.union(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)})
      })(modifierItemParameters)(Control$dBind.arrayBind(Data$dRecord.unsafeGet("sections")($0._1))(x => Data$dFunctor.arrayMap(Data$dTuple.snd)(x.items._2)))
    ]);
  }
  $runtime.fail();
});
const fromCustomParameterId = v => {
  if (v.tag === "CustomParameter") { return Data$dMaybe.$Maybe("Just", v._1); }
  return Data$dMaybe.Nothing;
};
const directProductCategoryParameters = catalogue => category => Data$dFoldable.foldableArray.foldMap({
  mempty: Data$dMap$dInternal.Leaf,
  Semigroup0: () => ({append: Data$dSet.union(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)})
})(x => x)([
  Data$dFoldable.foldlArray(Data$dSet.union(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId))(Data$dMap$dInternal.Leaf)(Data$dFunctor.arrayMap(modifierParameters(catalogue))(category.categoryModifiers)),
  Restaumatic$dMenu$dV2$dParametric.parametricParams(category.divisible)
]);
const directParameterParams = parameter => Data$dFoldable.foldableArray.foldMap({
  mempty: Data$dMap$dInternal.Leaf,
  Semigroup0: () => ({append: Data$dSet.union(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)})
})(x => x)(Data$dFunctor.arrayMap(Restaumatic$dMenu$dV2$dParametric.parametricParams)(Data$dFunctor.arrayMap(x => x.availableWhen)(Data$dFunctor.arrayMap(Data$dTuple.snd)(parameter.choices._2))));
const allModifiers = catalogue => product => Data$dSemigroup.concatArray((() => {
  const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(Data$dRecord.unsafeGet("category")(product))(Data$dRecord.unsafeGet("categories")(catalogue.catalogue));
  if ($0.tag === "Nothing") { return []; }
  if ($0.tag === "Just") { return Data$dRecord.unsafeGet("categoryModifiers")($0._1); }
  $runtime.fail();
})())(Data$dRecord.unsafeGet("productModifiers")(product));
const directProductParameters = catalogue => product => Data$dFoldable.foldableArray.foldMap({
  mempty: Data$dMap$dInternal.Leaf,
  Semigroup0: () => ({append: Data$dSet.union(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)})
})(x => x)([
  Restaumatic$dMenu$dV2$dParametric.parametricParams(product.price),
  Restaumatic$dMenu$dV2$dParametric.parametricParams(product.variants),
  Data$dFoldable.foldableArray.foldMap({mempty: Data$dMap$dInternal.Leaf, Semigroup0: () => ({append: Data$dSet.union(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)})})(x => x)(Data$dFunctor.arrayMap(modifierParameters(catalogue))(allModifiers(catalogue)(product))),
  (() => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(product.category)(Data$dRecord.unsafeGet("categories")(catalogue.catalogue));
    if ($0.tag === "Just") { return Restaumatic$dMenu$dV2$dParametric.parametricParams($0._1.divisible); }
    return Data$dMap$dInternal.Leaf;
  })(),
  Data$dList$dTypes.foldableList.foldMap({mempty: Data$dMap$dInternal.Leaf, Semigroup0: () => ({append: Data$dSet.union(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)})})(settings => Data$dMap$dInternal.unionWith(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Data$dFunction.const)(Restaumatic$dMenu$dV2$dParametric.parametricParams(Data$dRecord.unsafeGet("editable")(settings)))(Restaumatic$dMenu$dV2$dParametric.parametricParams(Data$dRecord.unsafeGet("inputRequired")(settings))))(Data$dMap$dInternal.values(Data$dRecord.unsafeGet("modifierSettings")(product)))
]);
const addDirectlyTransitiveParams = catalogue => initial => Data$dMap$dInternal.unionWith(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Data$dFunction.const)(initial)(Data$dFoldable.foldableArray.foldMap({
  mempty: Data$dMap$dInternal.Leaf,
  Semigroup0: () => ({append: Data$dSet.union(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)})
})(x => x)(Data$dFunctor.arrayMap(parameterId => Restaumatic$dMenu$dV2$dMemo.memoLookup(Restaumatic$dMenu$dV2$dMemo.ordParametersMemoKey)(catalogue.parametersMemo)(Restaumatic$dMenu$dV2$dMemo.$ParametersMemoKey(
  "ParameterParameters",
  parameterId
))(v => {
  const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(parameterId)(Data$dRecord.unsafeGet("customParameters")(catalogue.catalogue));
  if ($0.tag === "Nothing") { return Data$dMap$dInternal.Leaf; }
  if ($0.tag === "Just") { return directParameterParams($0._1); }
  $runtime.fail();
}))(Data$dArray.fromFoldableImpl(Data$dSet.foldableSet.foldr)(Data$dFoldable.foldlArray(m => a => Data$dMap$dInternal.insert(Data$dOrd.ordString)(a)()(m))(Data$dMap$dInternal.Leaf)(Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(fromCustomParameterId)(Data$dArray.fromFoldableImpl(Data$dSet.foldableSet.foldr)(initial))))))));
const withTransitiveParams = withTransitiveParams$a0$copy => withTransitiveParams$a1$copy => {
  let withTransitiveParams$a0 = withTransitiveParams$a0$copy, withTransitiveParams$a1 = withTransitiveParams$a1$copy, withTransitiveParams$c = true, withTransitiveParams$r;
  while (withTransitiveParams$c) {
    const catalogue = withTransitiveParams$a0, params = withTransitiveParams$a1;
    const paramsNext = addDirectlyTransitiveParams(catalogue)(params);
    if (Data$dMap$dInternal.eqMap(Restaumatic$dMenu$dV2$dTypes$dParameterId.eqParameterId)(Data$dEq.eqUnit).eq(params)(paramsNext)) {
      withTransitiveParams$c = false;
      withTransitiveParams$r = params;
      continue;
    }
    withTransitiveParams$a0 = catalogue;
    withTransitiveParams$a1 = paramsNext;
  }
  return withTransitiveParams$r;
};
const productCategoryParameters = catalogue => x => withTransitiveParams(catalogue)(directProductCategoryParameters(catalogue)(x));
const productParametersUncached = catalogue => x => withTransitiveParams(catalogue)(directProductParameters(catalogue)(x));
const productParameters = catalogue => productId => Restaumatic$dMenu$dV2$dMemo.memoLookup(Restaumatic$dMenu$dV2$dMemo.ordParametersMemoKey)(catalogue.parametersMemo)(Restaumatic$dMenu$dV2$dMemo.$ParametersMemoKey(
  "ProductParameters",
  productId
))(v => {
  const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(productId)(Data$dRecord.unsafeGet("products")(catalogue.catalogue));
  if ($0.tag === "Nothing") { return Data$dMap$dInternal.Leaf; }
  if ($0.tag === "Just") { return withTransitiveParams(catalogue)(directProductParameters(catalogue)($0._1)); }
  $runtime.fail();
});
export {
  addDirectlyTransitiveParams,
  allModifiers,
  directParameterParams,
  directProductCategoryParameters,
  directProductParameters,
  fromCustomParameterId,
  modifierItemParameters,
  modifierParameters,
  productCategoryParameters,
  productParameters,
  productParametersUncached,
  withTransitiveParams
};
